<div
  class="w-full rounded-lg flex flex-col justify-between py-3 pl-5 mb-4 pr-10 bg-gradient-to-r from-blue-400 to-blue-600 relative">
  <div class="flex flex-col text-white relative">
    <span class="title mb-3">Balance</span>
    <div class="min-h-[36px]">
      <div *ngIf="getUserWalletIsLoading$ | async; else notLoading" @fadeIn @fadeOutAbsolute>
        <div class="mt-1 animate-pulse flex items-end">
          <div class="bg-gray-400 rounded-lg h-8 w-24 mr-4"></div>
          <div class="bg-gray-400 rounded-lg h-6 w-10"></div>
        </div>
      </div>
      <ng-template #notLoading>
        <div class="flex justify-between items-end">
          <div class="flex items-end">
            <span class="amount text-3xl" [ngClass]="{ 'blur-md': hidden }">{{
              (userWallet$ | async)?.balance || 0
                | applyRoundingRules : country : 'collection'
                | currency : ' ' : 'symbol' : '1.0-0'
            }}</span
            ><span class="currency ml-3.5 pb-1">{{ userWalletCurrency$ | async }}</span>
          </div>
          <div *ngIf="hidable">
            <img
              src="assets/images/white-eye-closed.png"
              alt="hide icon"
              *ngIf="!hidden"
              class="cursor-pointer h-6"
              (click)="hidden = true" />
            <img
              src="assets/images/white-eye-open.png"
              alt="show icon"
              *ngIf="hidden"
              class="cursor-pointer h-6"
              (click)="hidden = false" />
          </div>
        </div>
      </ng-template>
      <div *ngIf="showTopUp" HasPermission [expectedPermission]="['business_org_collections_create']">
        <div class="border-b-2 mt-6 mb-2 border-blue-300"></div>
        <div class="flex justify-center items-center">
          <div class="flex gap-2 font-semibold cursor-pointer" (click)="onTopUpClick()">
            <img src="assets/images/white-card.png" alt="card icon" class="h-6" /> Top up
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
